export const APP_HOST = process.env.REACT_APP_HOST ?? 'localhost';
export const APP_PORT = process.env.REACT_APP_PORT ?? '3000';
